import { useEffect } from 'react';

import { useObservable } from '@hooks/useObservable';

import { contractStore } from '../contractStore';

/** Utility hook for obtaining contract data for the currently selected apartment.
 * If explicit contract ID is provided, contract data for that ID is returned */
export const useContract = (contractId?: string) => {
  const { id, contract, isFetching } = useObservable(
    () => ({
      id: contractId ?? contractStore.selectedContractId,
      contract: contractStore.getContract(
        contractId ?? contractStore.selectedContractId
      ),
      isFetching: contractStore.isFetching,
    }),
    [contractId]
  );

  useEffect(() => {
    if (
      contractId &&
      // fetch contract if it's not already available
      !contractStore.getContract(contractId) === undefined &&
      // ... or being fetched already
      !contractStore.isFetchingContract(contractId)
    ) {
      contractStore.fetchContract(contractId);
    }
  }, [contractId]);

  return {
    id,
    contract,
    isFetching,
    isError: !isFetching && !contract,
  };
};
